var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"majorTitle textLeft"},[_vm._v("\n    Favorites\n  ")]),_vm._v(" "),(_vm.type === 'items')?_c('div',[_c('FavoriteItems',{attrs:{"list-id":_vm.listId}})],1):_c('div',[_c('div',{on:{"click":function($event){return _vm.onTypeClick('items')}}},[_vm._v("\n      Items\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }